import React, { Component } from 'react';
import _ from 'lodash';

import FleximodoSensorsTable from '../components/FleximodoSensorsTable';
import FleximodoSensorsForm from '../components/FleximodoSensorsForm';
import FleximodoSensorsModel from '../components/FleximodoSensorsModel';

import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, Modal, message } from 'antd';
import FleximodoParkinglocationsSelect from '../components/FleximodoParkinglocationsSelect';

class FleximodoSensorsScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: true,
    dataAll: [],
    data: [],
    searchedTextValue: "",
    parkingLocationId: null,
    fleximodoSensorsSettingsFormModalVisible: false,
    mapModalVisible: false,
  }

  intervalId = null;

  componentWillMount() {
    this.loadData(this.state.parkingLocationId);

    // Checking auto reload data
    this.intervalId = setInterval(() => {
      if (this.state.autoReload) {
        this.loadData(this.state.parkingLocationId);;
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadData(parkingLocationId) {
    this.setState({
      dataLoading: true
    });
    FleximodoSensorsModel.getAll(parkingLocationId)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      })
      .then(() => {
        if (this.state.searchedTextValue) {
          this.onSearchDescription(this.state.searchedTextValue);
        }
      })
  }

  onSearchDescription(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => {
        if (typeof (d['serialNumber']) != 'undefined') {
          return d['serialNumber'].toLowerCase().includes(searchText.toLowerCase());
        } else {
          return dataAll
        }
        if (searchText == '') {
          return dataAll
        }
      })
    });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Fleximodo - Senzory</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
                <FleximodoParkinglocationsSelect
                  allowClear={true}
                  onChange={(value) => {
                    this.loadData(value);
                    this.setState({ searchedTextValue: "", locationId: value })
                  }}
                  style={{ width: 300 }}
                />
                <Input.Search
                  placeholder="Najít podle sériového čísla"
                  value={this.state.searchedTextValue}
                  onSearch={this.onSearchDescription.bind(this)}
                  onChange={(e) => {
                    this.setState({
                      searchedTextValue: e.target.value
                    })
                  }}
                  style={{ width: 300 }} />
              </Col>
              <Col span={10} offset={6} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData(this.state.parkingLocationId) }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>

                {UserModel.isInRoles(['ADMIN', 'FLEXIMODO_SENSORS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ fleximodoSensorsSettingsFormModalVisible: true }) }}>Nový senzor</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <FleximodoSensorsForm
            type="modal"
            modalVisible={this.state.fleximodoSensorsSettingsFormModalVisible}
            onModalCancel={(form) => {
              form.resetFields();
              this.setState({ fleximodoSensorsSettingsFormModalVisible: false })
            }}
            onSuccess={(form, values) => {
              FleximodoSensorsModel.create(values)
                .then(() => {
                  message.success("Senzor byl vložen!");
                  form.resetFields();
                  this.loadData(this.state.fleximodoSensorsSettingsFormModalVisible);
                })
                .catch((err) => {
                  message.warning('Data se nepodařilo uložit. Prosím kontaktujte správce systému!');
                });
            }} />

          <FleximodoSensorsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onAnyFormSuccess={() => {
              this.loadData(this.state.parkingLocationId);
            }}
            onRemoveRow={(serialNumber) => {
              FleximodoSensorsModel.remove(serialNumber)
                .then(() => {
                  this.loadData(this.state.parkingLocationId);
                })
                .catch((err) => {
                  message.warning('Senzor se nepodařilo smazat. Prosím kontaktujte správce systému!');
                });
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default FleximodoSensorsScreen;



// WEBPACK FOOTER //
// ./src/screens/FleximodoSensorsScreen.js